import { useQuery } from "react-query";
import { API_KEY_GET_ADMIN_TOTALS, getTotals } from "../api";

export const useGetTotals = (params) => {
  return useQuery([API_KEY_GET_ADMIN_TOTALS, params], () => getTotals(params));
};
